import { Component, Input } from '@angular/core';
import { OthersSpecification } from 'icreate/common/models/system-specification';

@Component({
    selector: 'app-other-specifications',
    templateUrl: './other-specifications.component.html',
    styleUrl: './other-specifications.component.css',
    standalone: false,
})
export class OtherSpecificationsComponent {
    @Input() othersSpecification: OthersSpecification;
    @Input() userCanEdit: boolean;

    onItemsTextAreaChange(value) {
        this.othersSpecification.items = value;
    }

    onNotesTextAreaChange(value) {
        this.othersSpecification.notes = value;
    }
}
